import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";

@Component({
  selector: "app-upload-result-dialog",
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: "./upload-result-dialog.component.html",
  styles: [
    `
      :host ::ng-deep {
        display: block;
        background-color: #202125;
        color: #fff;
        border-radius: 12px;
      }
      :host ::ng-deep .dialog-content {
        max-height: 400px;
        overflow-y: auto;
        padding: 0 24px;
      }
      :host ::ng-deep .table {
        width: 100%;
        margin-bottom: 1rem;
        color: #d1d5db !important;
        border-color: #444 !important;
        --bs-table-bg: transparent;
        --bs-table-color: #d1d5db;
        --bs-table-border-color: #444;
        --bs-table-striped-bg: rgba(255, 255, 255, 0.05);
        --bs-table-striped-color: #d1d5db;
      }
      :host ::ng-deep .table > :not(caption) > * > * {
        background-color: transparent !important;
        color: #d1d5db !important;
        border-bottom: 1px solid #444 !important;
        padding: 0.75rem;
      }
      :host ::ng-deep .table th,
      :host ::ng-deep .table td {
        padding: 0.75rem;
        vertical-align: top;
        border: 1px solid #444 !important;
        color: #d1d5db !important;
      }
      :host ::ng-deep .table thead th,
      :host ::ng-deep .table > thead > tr > th {
        vertical-align: bottom;
        border-bottom: 2px solid #555 !important;
        background-color: #232322 !important;
        color: #fff !important;
        font-weight: 500;
        border-top: none !important;
      }
      :host ::ng-deep .table-bordered {
        border: 1px solid #444 !important;
      }
      :host ::ng-deep .table-striped > tbody > tr:nth-of-type(odd) > * {
        background-color: rgba(255, 255, 255, 0.05) !important;
        color: #d1d5db !important;
      }
      :host ::ng-deep .table-striped > tbody > tr:nth-of-type(even) > * {
        background-color: transparent !important;
        color: #d1d5db !important;
      }
      :host ::ng-deep .text-danger {
        color: #ff6b6b !important;
      }
      :host ::ng-deep .text-success {
        color: #38d9a9 !important;
      }
      :host ::ng-deep h5 {
        margin-top: 1.5rem;
        margin-bottom: 0.5rem;
        font-weight: 500;
        font-size: 1.1rem;
        color: #fff;
      }
      :host ::ng-deep p {
        color: #ccc;
        margin-bottom: 1rem;
        padding-top: 10px;
      }
      :host ::ng-deep h2[mat-dialog-title] {
        margin: 0;
        padding: 24px 24px 16px 24px;
        color: #fff;
        font-size: 1.25rem;
      }
      :host ::ng-deep .dialog-actions {
        padding: 16px 24px 24px 24px !important;
      }
      :host ::ng-deep .dialog-actions button {
        color: #fff !important;
        background-color: rgba(255, 255, 255, 0.05);
        border: 1px solid #444;
        transition: background-color 0.2s, border-color 0.2s;
        border-radius: 6px;
        padding: 0 16px;
      }
      :host ::ng-deep .dialog-actions button:hover {
        background-color: rgba(255, 255, 255, 0.1);
        border-color: #666;
      }
    `,
  ],
})
export class UploadResultDialogComponent {
  constructor(public dialogRef: MatDialogRef<UploadResultDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { createdStudents: any[]; existingStudents: any[]; errors: any[]; message: string }) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
